<script setup>
import { computed } from '#imports';
import { formatNewsTime } from '~/utils/format-news-date';

const props = defineProps({
  date: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  slug: {
    type: String,
    required: true,
  },
  highlightedWord: {
    type: String,
    default: '',
  },
  border: {
    type: Boolean,
  },
});

const formattedTime = computed(() => formatNewsTime(props.date), {
  cache: true,
});
const titleWords = props.title.split(' ');
</script>

<template>
  <div class="news-page-item">
    <div class="news-page-item__date">{{ formattedTime }}</div>
    <NuxtLink v-if="highlightedWord" :to="`/news/${props.slug}`">
      <div v-for="(word, index) in titleWords" :key="index">
        <span
          :class="
            word.toLowerCase() === props.highlightedWord.toLowerCase()
              ? 'highlight'
              : ''
          "
          >{{ word }}</span
        >
        <span v-if="index < titleWords.length - 1">&nbsp;</span>
      </div>
    </NuxtLink>

    <NuxtLink
      v-else
      :to="`/news/${props.slug}`"
      :class="props.border && 'news-page-item--chronic'"
    >
      {{ props.title }}
    </NuxtLink>
  </div>
</template>

<style lang="postcss" scoped>
.news-page-item {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
  font-family: var(--body-font-family), serif;
  font-size: var(--body-font-size);
  padding: 2px;

  & a::after {
    content: '';
    box-shadow: 0 0 0 1px rgba(17, 17, 17, 10%);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 8px;
  }

  &--chronic {
    margin-top: 8px;
    box-shadow: 0 0 0 2px var(--accent-color);
  }

  &__date {
    color: rgba(14, 14, 14, 40%);
    font-size: 14px;
    line-height: 22px;
  }

  a {
    position: relative;
    background-color: rgba(245, 234, 243, 100%);
    border-radius: 8px;
    padding: 16px;
    font-family: var(--body-font-family), serif;
    color: #000;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    transition: background-color 0.3s ease-in-out;

    .highlight {
      color: #762c80;
      font-weight: 600;
      text-decoration: underline;
    }

    @media (--desktop-vp) {
      &:hover::after {
        opacity: 1;
      }
    }
  }
}
</style>
